import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-8% 0px" }}
  >
    <motion.span
      className={`block will-change-transform ${className}`}
      variants={{
        hidden: { y: "115%" },
        show: { y: "0%", transition: { duration: 1, delay, ease: EASE } },
      }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-10% 0px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ index, label, dark = false }) => (
  <Reveal>
    <div
      data-testid={`chapter-${label.toLowerCase().replace(/\s+/g, "-")}`}
      className={`flex items-center gap-4 font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] ${
        dark ? "text-white/50" : "text-[#5A6E85]"
      }`}
    >
      <span className={dark ? "text-[#D4AF37]" : "text-[#12294D]"}>{index}</span>
      <span className={`h-px w-10 ${dark ? "bg-white/20" : "bg-[#08162B]/20"}`} />
      <span>{label}</span>
    </div>
  </Reveal>
);
